const getters = {
  userName: (state) => state.app.userName,
  accessToken: (state) => state.userInfo.accessToken,
  token: (state) => state.userInfo.token,
  searchList: (state) => state.search.searchList,
  hotList: (state) => state.search.hotList,
};
export default getters;
